<script>
import Topbar from '@components/topbar'
import AppMenu from '@components/app-menu'
import RightSidebar from '@components/right-sidebar'
import { mainRoutes } from '@routes'

export default {
  components: { Topbar, AppMenu, RightSidebar },
  data() {
    return {
      showMobileMenu: false,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
      menuItems: mainRoutes,
    }
  },
  created: () => {
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
    document.body.setAttribute('data-layout', 'topnav')
    document.body.classList.remove('right-bar-enabled')
    document.body.classList.remove('left-side-menu-condensed')
    document.body.classList.remove('boxed-layout')
  },
  mounted() {

  },
  methods: {
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    },
  },
}
</script>

<template>
  <div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->
    <div class="wrap-menu">
      <Topbar :user="user" :is-menu-opened="showMobileMenu" />
      <div class="topnav shadow-sm">
        <div class="container-fluid">
          <nav class="navbar navbar-light navbar-expand-lg topbar-nav">
            <b-collapse
              id="topnav-menu-content"
              v-model="showMobileMenu"
              class="navbar-collapse"
            >
              <AppMenu v-if="menuItems.length > 0" mode="horizontal" :menuProps="menuItems" />
            </b-collapse>
          </nav>
        </div>
      </div>
    </div>
    <div class="content-page">
      <div class="content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
    </div>
    <RightSidebar />
  </div>
</template>

<style lang="scss">
.wrap-menu {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  height: 60px;
  background-color: #fff;
  -webkit-box-shadow: 0 0.05rem 0.01rem rgb(75 75 90 / 8%);
  box-shadow: 0 0.05rem 0.01rem rgb(75 75 90 / 8%);
}
</style>
